import React from 'react';
import HeroSection from '../sections/heroSection';
import Statistics from '../sections/statistics';
import TextWithImage from '../sections/textWithImage';
import Testimonials from '../components/testimonials';
import Rebels from '../images/about/about-img-2.jpg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import '../styles/pages/about.scss';


const content = {
    "heroSection": {
        "title": "About Us",
        "subtext": "<strong>Creating a distinct value</strong><br /> and polishing brand assets<br /> from the inside and out.",
        "image": require('../images/about/about-banner.png')
    },
    "statistics": {
        "columns": 4,
        "stats": [
            {
                "count": "150+",
                "content": "Employees"
            },
            {
                "count": "3",
                "content": "LOCATIONS"
            },
            {
                "count": "9+",
                "content": "YEARS"
            },
            {
                "count": "1000+",
                "content": "Happy Customers"
            }
        ]
    },
    "textWithImage":{
        "enable": true,
        "content": "A bunch of creative rebels who believe design can empower team of creative knuckleheads with the honed expertise to empower people, businesses and the digital world at large.",
        "image": require('../images/about/about_img-1.jpg')
      }
}

const About = () => {
    //add class to body
    const body = document.body;
    body.classList = 'template-about';

    return(
        <div className="innerWrapper">
            {content.heroSection &&
                <HeroSection data={content.heroSection} />
            }
            {content.statistics &&
                <Statistics data={content.statistics} />
            }
            <div className="sections whiteBg">
                {content.textWithImage &&
                    <TextWithImage data={content.textWithImage} />
                }  
                <div className="whyMobikasa">
                    <div className="innerBox lg">
                        <h4 className="sectionSubHeading">WHY MOBIKASA?</h4>
                        <h3 className="sectionHeading">Creative rebels with principles</h3>
                        <div className="wmInner">
                            <div className="imageContainer">
                            <LazyLoadImage
                                alt="Creative rebels with principles"
                                className="zoom-in-out-2"
                                effect="blur"
                                src={Rebels} // use normal <img> attributes as props
                                />
                            </div>
                            <ul className="contentSection">
                                <li>
                                    <p>SUPERLATIVE PROCESS</p>
                                    <span>Our innovative tech-driven processes<br /> blend efficiency and effectiveness<br /> that drives value to your business.</span>
                                </li>
                                <li>
                                    <p>SCIENCE AND EMOTIONS</p>
                                    <span>Driven by factual research, we craft progressive yet empathetic solutions.</span>
                                </li>
                                <li>
                                    <p>EXCELLENT BY NATURE</p>
                                    <span>We settle for nothing less! We create<br /> designs to attract and inspire.</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="testimonials tac">
                    <div className="innerBox lg">
                        <p>We’re strategists, designers, developers,<br /> writers, directors & producers united by our<br /> pioneering spirit.</p>
                        <Testimonials />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About;